import { CommonModule } from "@angular/common";
import { SecureGuard } from "../secure/secureGaurd";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { FullCalendarModule } from '@fullcalendar/angular';
import { SharedModule } from "../shared/shared.module";
import { AddpackageBuilderComponent } from "../shared/addpackage-builder/addpackage-builder.component";
import { ToastModule } from "primeng/toast";
import { DataViewModule } from "primeng/dataview";
import { TableModule } from "primeng/table";
import { AppServiceManager } from "common/services/appServiceManager";
import { Configuration } from "config/config";
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessageModule } from "primeng/message";
import { ButtonModule } from "primeng/button";
import { MessagesModule } from "primeng/messages";
import { TabMenuModule } from "primeng/tabmenu";
import { TooltipModule } from "primeng/tooltip";
import { StepsModule } from "primeng/steps";
import { PanelModule } from "primeng/panel";
import { DropdownModule } from "primeng/dropdown";
import { TabViewModule } from "primeng/tabview";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { FileUploadModule } from "primeng/fileupload";
import { CalendarModule } from "primeng/calendar";
import { DialogModule } from "primeng/dialog";
import { RadioButtonModule } from "primeng/radiobutton";
import { CheckboxModule } from "primeng/checkbox";
import { ToolbarModule } from "primeng/toolbar";
import { ListboxModule } from "primeng/listbox";
import { ColorPickerModule } from "primeng/colorpicker";
import { BookingsComponent } from "./bookings/bookings.component";
import { BookingComponent } from "./booking/booking.component";


const BookingsManagement_Routes: Routes = [
    { path: "", component: BookingsComponent, canActivate: [SecureGuard] },
    {
        path: "booking",
        component: BookingComponent,
        canActivate: [SecureGuard],
    },
    {
        path: "booking/:id",
        component: BookingComponent,
        canActivate: [SecureGuard],
    },
];

@NgModule({
    declarations: [
        BookingsComponent,
        BookingComponent,
    ],
    imports: [
        SharedModule,
        ToolbarModule,
        DataViewModule,
        FormsModule,
        ToastModule,
        FullCalendarModule,
        CalendarModule,
        TabViewModule,
        PanelModule,
        DialogModule,
        TableModule,
        CommonModule,
        DropdownModule,
        RouterModule.forChild(BookingsManagement_Routes),
    ],
    providers: [AppServiceManager, SecureGuard, Configuration],
})
export class BookingsManagementModule {}
